import React, { useState } from 'react';
import './OverlayHogar.css';

const OverlayHogar = ({ onContinue, onVerPlanos, onBackClick }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="overlay-hogar">
      <div className={`overlay-hogar-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <button className="overlay-back-btn" onClick={onBackClick}>
          <span className="material-symbols-outlined">arrow_back</span>
        </button>

        <div className="overlay-hogar-header">
          <button 
            className="overlay-toggle-btn" 
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <span className="material-symbols-outlined">
              {isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
            </span>
          </button>
        </div>
        
        <img
          src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 1.png'}
          alt="Logo Garden"
          className="overlay-hogar-logo"
        />
        
        {isExpanded && (
          <>
            <div className="overlay-hogar-btns">
              <button className="overlay-hogar-btn overlay-hogar-btn-main" onClick={onContinue}>
                Recorrido
              </button>
              <button
                className="overlay-hogar-btn overlay-hogar-btn-link"
                onClick={onVerPlanos}
              >
                Exteriores
              </button>
              <button className="overlay-hogar-btn overlay-hogar-btn-link" onClick={() => window.open('https://www.surrealismo.co/Panoramas/Estrella/Garden/', '_blank')}>
                Visita virtual
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OverlayHogar; 